import { ContextHost } from '../service/contextHost.js';
import { httpServiceHost, stakingSubgraphServiceHost } from '../serviceHost.js';
import { http } from '../utils/request/index.js';
import {} from './type.js';
import { BigNumber } from 'bignumber.js';
import { GraphQLClient, gql } from 'graphql-request';
function timeoutAsync(timeout, callback) {
    return new Promise((_, reject) => {
        setTimeout(() => {
            callback();
            reject(new Error('The user aborted a request.'));
        }, timeout);
    });
}
async function requestWithTimeout(timeout, url, query, variables = {}) {
    const controller = new AbortController();
    const timeoutPromise = timeoutAsync(timeout, () => {
        return controller.abort();
    });
    const client = new GraphQLClient(url, {
        signal: controller.signal,
    });
    return Promise.race([client.request(query, variables), timeoutPromise]);
}
export class Staking extends ContextHost {
    _timeout;
    _STAKING_SUBGRAPH_URL;
    constructor(config) {
        super({ env: config.env, chainId: config.chainId });
        this._timeout = config.timeout ?? 2 * 60 * 1000;
        this._STAKING_SUBGRAPH_URL = stakingSubgraphServiceHost[config.env];
    }
    async fetchStakingDashboard() {
        const lonCirculation = await http(`${httpServiceHost[this.env]}/v1/referral/lon/staking/circulation`);
        const latestApy = await http(`${httpServiceHost[this.env]}/v1/referral/lon/staking/apy`);
        if (lonCirculation && latestApy) {
            const { scaleIndex } = latestApy;
            const { staked: totalStakedAmount } = lonCirculation;
            const totalStakedAmountBN = new BigNumber(totalStakedAmount);
            const scaleIndexBN = new BigNumber(scaleIndex);
            return {
                totalStakedAmount: totalStakedAmountBN.toString(),
                totalXlonSupply: totalStakedAmountBN.div(scaleIndexBN).toString(),
                scaleIndex: scaleIndexBN.toString(),
            };
        }
        throw new Error('Fail to fetch dashboard data for tokenlon staking');
    }
    async fetchStakingList(userAddr, page, pageCount) {
        const query = gql `
      query StakingRecords(
        $user: String,
        $first: Int,
        $skip: Int
      ) {
        stakingRecords (
          first: $first
          skip: $skip
          orderBy: timestamp
          orderDirection: desc
          where: { user: $user }
        ) {
          id
          transactionHash
          blockNumber
          logIndex
          date
          timestamp
          amount
          penalty
          share
          redeem
          stakeType
          cooldownSeconds
          cooldownDate
        }
      }
    `;
        const resp = (await requestWithTimeout(this._timeout, this._STAKING_SUBGRAPH_URL, query, {
            user: userAddr,
            first: pageCount,
            skip: page > 0 ? (page - 1) * pageCount : 0,
        }));
        if (resp.stakingRecords) {
            return resp.stakingRecords.map((stakingRecord) => {
                const record = {
                    id: stakingRecord.id,
                    transactionHash: stakingRecord.id,
                    blockNumber: Number.parseInt(stakingRecord.blockNumber),
                    logIndex: Number.parseInt(stakingRecord.logIndex),
                    date: stakingRecord.date,
                    timestamp: stakingRecord.timestamp,
                    amount: BigInt(stakingRecord.amount),
                    penalty: BigInt(stakingRecord.penalty),
                    share: Number.parseInt(stakingRecord.share),
                    redeem: stakingRecord.redeem,
                    stakeType: stakingRecord.stakeType,
                    cooldownSeconds: Number.parseInt(stakingRecord.cooldownSeconds),
                    cooldownDate: stakingRecord.cooldownDate,
                };
                return record;
            });
        }
        throw new Error('Fail to fetch tokenlon staking list');
    }
}
//# sourceMappingURL=index.js.map